import React from "react";
import HeaderInner from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Contact from "../elements/ContactTwo";
import Footer from '../elements/Footer';





function ContactPage() {

  return (
    <div className='contact-page'>
        <div className="">
            <HeaderInner/>
            <main>
                <Breadcrumb title="Contact Us" sub_title="Home" active="Contact Us"/>
                   <Contact/>
                    
                    {/* <div className="tmp-map-area tmp-sectiongapBottom">
                        <div className="map-area-flotimg-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56516.2859130569!2d85.24819285450387!3d27.709014520769113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb198a307baabf%3A0xb5137c1bf18db1ea!2sKathmandu%2044600%2C%20Nepal!5e0!3m2!1sen!2sbd!4v1714324837639!5m2!1sen!2sbd"
                            width={600}
                            height={650}
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                        </div>
                    </div> */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default ContactPage